/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryProjectResponse } from './RevisdomAPIViewModelsEntryProjectResponse';
import {
    RevisdomAPIViewModelsEntryProjectResponseFromJSON,
    RevisdomAPIViewModelsEntryProjectResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryProjectResponseToJSON,
    RevisdomAPIViewModelsEntryProjectResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryProjectResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1ProjectResponse
 */
export interface ApiResponse1ProjectResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1ProjectResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1ProjectResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryProjectResponse}
     * @memberof ApiResponse1ProjectResponse
     */
    data?: RevisdomAPIViewModelsEntryProjectResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1ProjectResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1ProjectResponse interface.
 */
export function instanceOfApiResponse1ProjectResponse(value: object): value is ApiResponse1ProjectResponse {
    return true;
}

export function ApiResponse1ProjectResponseFromJSON(json: any): ApiResponse1ProjectResponse {
    return ApiResponse1ProjectResponseFromJSONTyped(json, false);
}

export function ApiResponse1ProjectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1ProjectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryProjectResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1ProjectResponseToJSON(json: any): ApiResponse1ProjectResponse {
    return ApiResponse1ProjectResponseToJSONTyped(json, false);
}

export function ApiResponse1ProjectResponseToJSONTyped(value?: ApiResponse1ProjectResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryProjectResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

